import { render } from "./Start.vue?vue&type=template&id=310fc8ed"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&id=310fc8ed&lang=css"
script.render = render

export default script